import React from 'react';
import { ArrowRight } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'primary' | 'outline' | 'white';
    withIcon?: boolean;
}

export const Button: React.FC<ButtonProps> = ({ 
    children, 
    variant = 'primary', 
    withIcon = false, 
    className = '',
    ...props 
}) => {
    const baseStyles = "inline-flex items-center justify-center px-8 py-3 rounded-full font-medium transition-all duration-300 active:scale-95";
    
    const variants = {
        primary: "bg-[#11BC97] text-white hover:bg-[#0da082] shadow-lg hover:shadow-[#11BC97]/30",
        outline: "border-2 border-[#11BC97] text-[#11BC97] hover:bg-[#11BC97] hover:text-white",
        white: "bg-white text-black hover:bg-gray-100"
    };

    return (
        <button 
            className={`${baseStyles} ${variants[variant]} ${className}`} 
            {...props}
        >
            {children}
            {withIcon && <ArrowRight className="ml-2 w-4 h-4" />}
        </button>
    );
};